import styled, { css } from 'styled-components';

export const BlockSizeSelectorSC = styled.div`
  width: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;

  label {
    margin: 0;
    margin-right: 10px;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;

    /* identical to box height, or 143% */

    color: #464b5d;
  }

  .size-actions {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .units {
    margin-left: 6px;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;

    /* identical to box height, or 143% */

    color: #464b5d;
  }
`;

export const SizeButton = styled.button<{ active?: boolean }>`
  margin: 0 3px;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  aspect-ratio: 1 / 1;
  border: none;
  border-radius: 10px;
  cursor: pointer;

  ${({ active }) =>
    active
      ? css`
          color: #ffffff;
          background: #6ad5e5;
        `
      : css`
          color: #181e34;
          background: #f7f7f9;
        `}
  .text {
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;

    /* identical to box height, or 143% */

    text-align: center;
  }
`;
